<app-spinner-overlay></app-spinner-overlay>
<div class="contenitore">
  <div class="titolo-pagina">
    <app-titolo-subtitolo
      titolo="Policy di Sostenibilità"
      subTitolo="Crea la tua Policy di Sostenibilità ed elabora un documento che descrive gli impegni presi dall’azienda sulle singole tematiche di sostenibilità.<br>Collegando la tua Policy di Sostenibilità agli altri moduli potrai usufruire delle informazioni inserite precedentemente."
    ></app-titolo-subtitolo>
  </div>
  <app-lista-tabellare
    #tabella
    [fnCaricamentoDati]="fnCaricamentoDati"
    [colonne]="colonne"
    [filtri]="filtri"
    (bottoniListaClick)="bottoniListaClick($event)"
  >
    <div btnEnd>
      <button
        *ngIf="this.utenteService.isPermessoAttivo('CREATE_POLICY')"
        mat-flat-button
        class="primary-button"
        color="primary"
        (click)="crea()"
      >
        Nuovo
      </button>
      <!-- *ngIf="this.utenteService.isPermessoAttivo('CREATE_POLICY')" -->
    </div>
  </app-lista-tabellare>
</div>
